import React, { useEffect, useState } from 'react';
import { Grid, Button, Box, TextField, MenuItem } from '@mui/material';
import { MotionTimer } from '../../motion-detect/MotionTimer';
import { useParams } from 'react-router-dom';
import { OrgSeason } from '../../api/models/orgSeason';
import { Team } from '../../api/models/team';
import { PersonView } from '../../models/personView';
import { useApi } from '../../hooks/useApi';
import { getSingleOrgSeasonApi } from '../../api/orgSeasonApi';
import { groupBy } from '../../utils/common';

export function TimerAppPage() {

   const [orgSeason, setOrgSeason] = useState<OrgSeason | undefined>(undefined);
      const [divisions, setDivisions] = useState<Map<string, Team[]> | undefined>(undefined);
      const [selectedDivision, setSelectedDivision] = useState<string>('');
      const [selectedTeam, setSelectedTeam] = useState<Team | undefined>(undefined);
      const [filteredPersonList, setFilteredPersonList] = useState<PersonView[]>([]);
      const [selectedPerson, setSelectedPerson] = React.useState<PersonView | undefined>(undefined);

    const [timer, setTimer] = useState<number>(0); // Timer state
    const [isRunning, setIsRunning] = useState<boolean>(false); // Timer running state

    const gunshotAudio = new Audio('/sounds/gunshot.mp3');

    const getOrgSeasonApi = useApi(getSingleOrgSeasonApi);

    const params = useParams();

        useEffect(() => {
            initPage();
        }, []);

        function initPage(){

          if (params.orgSeasonId) {
            getOrgSeasonApi.request(params.orgSeasonId);
          }
      }

        useEffect(() => {
            if (getOrgSeasonApi.data) {
                setOrgSeason(getOrgSeasonApi.data);
                const teams = getOrgSeasonApi.data.teams;
                const divisionList = groupBy<string, Team>(teams, team => team.division);
                setDivisions(divisionList);
            }
        }, [getOrgSeasonApi.data]);

            const selectDivision = (event: React.ChangeEvent<HTMLInputElement>) => {
                setSelectedDivision(event.target.value);
        
                //setImage(undefined);
                //setPageState('reset');
                setSelectedTeam(undefined);
                setFilteredPersonList([]);
            };
        
            const selectTeam = (event: React.ChangeEvent<HTMLInputElement>) => {
                const selectedTeamId = event.target.value;
                const selectedTeam = divisions?.get(selectedDivision)?.find(team => team.id === selectedTeamId);
                if (selectedTeam) {
                    setSelectedTeam(selectedTeam);
                    const personList = generatePersonList(selectedTeam);
                    setFilteredPersonList(personList);
        
                    //setImage(undefined);
                    //setPageState('reset');
                }
                else {
                    //setErrorMessage('could not find the selected team!');
                }
            };

             function generatePersonList(team: Team): PersonView[] {
                    let personList: PersonView[] = [];
            
                    if (team.athletes) {
                        const sortedMembers = team.athletes.sort((a, b) => a.lastName.localeCompare(b.lastName));
                        const memberPersons = sortedMembers.map((member) => ({ guid: member.id, isLeader: false, displayName: `${member.lastName}, ${member.firstName}`, profileLink: member.profileLink }));
                        personList = personList.concat(memberPersons);
                    }
            
                    if (team.leaders) {
                        const sortedLeaders = team.leaders.sort((a, b) => a.lastName.localeCompare(b.lastName));
                        const leaderPersons = sortedLeaders.map((leader) => ({ guid: leader.id, isLeader: true, displayName: `${leader.lastName}, ${leader.firstName} - ${leader.title}`, profileLink: leader.profileLink }));
                        personList = personList.concat(leaderPersons);
                    }
            
                    return personList;
                }
            
                async function selectPerson(event: React.ChangeEvent<HTMLInputElement>) {
                    const selectedPersonId = event.target.value;
                    const selectedPerson = filteredPersonList.find(person => person.guid === selectedPersonId);
            
                    
            
                    setSelectedPerson(selectedPerson);
                    //setPageState('personSelected');
                };
  
    // Start the timer
    const startTimer = () => {
      gunshotAudio.play(); // Play the gunshot sound
      setTimer(0); // Reset the timer
      setIsRunning(true); // Start the timer
      
    };
  
    // Stop the timer
    const stopTimer = () => {
      setIsRunning(false); // Stop the timer
    };

      // Reset the timer
  const resetTimer = () => {
    setTimer(0); // Reset the timer to 0
    setIsRunning(false); // Optionally stop the timer
  };
  
    // Update the timer every second when running
    useEffect(() => {
      let interval: NodeJS.Timeout | null = null;
  
      if (isRunning) {
        interval = setInterval(() => {
          setTimer((prev) => prev + 1); // Increment the timer
        }, 10);
      } else if (!isRunning && interval) {
        clearInterval(interval); // Clear the interval when stopped
      }

      return () => {
        if (interval) clearInterval(interval); // Cleanup on unmount
      };
    }, [isRunning]);
  
    // Handle motion detection
    const handleMotionDetected = () => {
      console.log("Motion detected! Timer stopped.");
      stopTimer(); // Stop the timer when motion is detected
    };
  
    return (
      <Box>
        <br />
        {  params.orgSeasonId && 
       <Grid item container spacing={2} direction='column' >
       
                          <Grid item >
                              <TextField select
                                  fullWidth
                                  label="Select "
                                  size="small"
                                  value={selectedDivision}
                                  onChange={selectDivision}
                                  helperText="Select a division">
                                  {orgSeason && orgSeason.divisions.map(option => (<MenuItem key={option} value={option}>{option}</MenuItem>))}
                              </TextField>
                          </Grid>
      
                          <Grid item>
                              <TextField select
                                  fullWidth
                                  label="Select"
                                  size="small"
                                  value={selectedTeam?.id ?? ''}
                                  onChange={selectTeam}
                                  helperText="Select a team">
                                  {divisions && divisions.get(selectedDivision)?.map(option => (<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>))}
                              </TextField>
                          </Grid>
      
                          <Grid item>
                              <TextField select
                                  fullWidth
                                  label="Select"
                                  size="small"
                                  value={selectedPerson?.guid ?? ''}
                                  onChange={selectPerson}
                                  helperText="Select a member">
                                  {filteredPersonList.map(option => (<MenuItem key={option.guid} value={option.guid}>{option.displayName}</MenuItem>))}
                              </TextField>
                          </Grid>
                          </Grid>}
                          


        <h1>Motion Detection Timer</h1>
        <h2>Timer: {timer/100} seconds</h2>

        <Box display="flex" justifyContent="flex-start" gap={2} marginBottom={2}>

        <Button color="primary"
                            variant="contained"
                            disabled={isRunning} 
                            onClick={e => startTimer()} >
                            Start
                        </Button>

                        <Button color="primary"
                            variant="contained"
                            disabled={!isRunning} 
                            onClick={e => stopTimer()} >
                            Stop
                        </Button>

                        <Button color="primary"
                            variant="contained"
                            disabled={!isRunning} 
                            onClick={e => resetTimer()} >
                            Reset
                        </Button>

                        </Box>


        <MotionTimer width={300} height={300} onMotionDetected={handleMotionDetected} />
      </Box>
    );


}